import { render, staticRenderFns } from "./SelectPrintingTemplate.vue?vue&type=template&id=66b97a2b&scoped=true&"
import script from "./SelectPrintingTemplate.vue?vue&type=script&lang=js&"
export * from "./SelectPrintingTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SelectPrintingTemplate.vue?vue&type=style&index=0&id=66b97a2b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b97a2b",
  null
  
)

export default component.exports